<template>
  <el-dialog
    :append-to-body="true"
    title="Форма добавления платежки"
    :visible="visible"
    :width="isMobile ? '95%' : '90%'"
    class="payment-adding-form"
    :close-on-click-modal="false"
    @close="closeModal"
  >
    <template v-if="!result">
      <h3>Скопировать вставить из реестра оплат</h3>
      <el-input
        v-model="textarea"
        style="font-size: 5px; margin-bottom: 20px"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 15 }"
        placeholder="Скопировать вставить из реестра оплат"
      />
      <el-select
        v-model="bank"
        placeholder="Выберите банк"
        style="width: 250px; margin-right: 16px"
      >
        <el-option
          v-for="item in banks"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="primary" @click="doPayDocResult(true)">
        Сформировать платежку
      </el-button>
    </template>
    <template v-else>
      <el-form ref="paymentAddingForm" :model="paymentAddForm">
        <el-form-item
          prop="orgInn"
          :rules="{
            required: true,
            message: 'Необходимо выбрать юридическое лицо',
            trigger: 'change',
          }"
        >
          <el-select
            v-model="paymentAddForm.orgInn"
            placeholder="Выберите юр. лицо"
            size="mini"
            clearable
            :disabled="paymentAddLoading"
            style="width: 250px"
          >
            <el-option
              v-for="item in performers"
              :key="item.id"
              :label="item.short_name"
              :value="item.inn"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <h3>Или исправьте ошибки или скачайте платежку</h3>
      <el-row :colspan="24" style="margin-bottom: 20px">
        {{ resultPayDocData }}
        <b v-if="!resultPayDocData.length">Ошибок нет!</b>
        <p>
          <el-link
            :disabled="paymentAddLoading"
            type="primary"
            @click="doPayDocResult(false)"
          >
            Скачать платежку
          </el-link>
        </p>
        <p>
          Номер первой платежки:
          <el-input
            v-model="numDocPay"
            :disabled="paymentAddLoading"
            label="Номер платежки"
          />
        </p>
      </el-row>
      <el-button
        type="primary"
        :loading="paymentAddLoading"
        @click="doNewPayDocResult"
      >
        Новый ввод
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { banksList } from '@/views/Documents/constants'
import { mapActions, mapGetters } from 'vuex'
import Repository from '@/api/Repository'

export default {
  name: 'AddingPaymentModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paymentAddLoading: false,
      paymentAddForm: {
        orgInn: '',
      },
      textarea: '',
      bank: 'sber',
      banks: banksList,
      resultPayDocData: '',
      numDocPay: '',
    }
  },
  computed: {
    ...mapGetters({
      isOrgs: 'organizations/isOrgs',
      performers: 'organizations/getOrganizations',
    }),
  },
  mounted() {
    if (!this.isOrgs) {
      this.fetchOrganizations({ can_be_performer: 1 })
    }
  },
  methods: {
    ...mapActions('organizations', ['fetchOrganizations']),
    doPayDocResult(error = false) {
      let ext = ''
      let extBuf
      const data = {
        documents_text: this.clearTabNewRow(this.textarea),
        first_document_id: this.numDocPay,
        bank: this.bank,
      }

      if (error) {
        ext = '?get-errors=1'
      } else {
        this.$refs.paymentAddingForm.validate(valid => {
          if (valid) {
            data.org_inn = this.paymentAddForm.orgInn
            extBuf = { responseType: 'arraybuffer' }
          }
        })
      }
      this.paymentAddLoading = true
      Repository.post('/txt-builder/template/payments' + ext, data, extBuf)
        .then(response => {
          if (error) {
            this.resultPayDocData = response.data
          } else {
            this.forceFileDownload(response, 'tobank.txt')
          }
        })
        .catch(err => this.errHandler(err))
        .finally(() => {
          this.$emit('true')
          this.paymentAddLoading = false
        })
    },
    clearTabNewRow() {
      return this.textarea.replace(/\t/g, '_tab_').replace(/\n/g, '_break_')
    },
    doNewPayDocResult() {
      this.$emit('false')
      this.textarea = ''
      this.bank = 'sber'
    },
    closeModal() {
      this.bank = 'sber'
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
